import script from "./budget-actions-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./budget-actions-select.vue?vue&type=script&setup=true&lang=ts"

import "./budget-actions-select.vue?vue&type=style&index=0&id=fbef97bf&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbef97bf"]])

export default __exports__